export const NOTIFICATIONS_RECEIVED_NEW = "NOTIFICATIONS_RECEIVED_NEW";
export const UPDATE_NOTIFICATIONS_DATA = "UPDATE_NOTIFICATIONS_DATA";
export const REMOVE_ALL_NOTIFICATIONS = "REMOVE_ALL_NOTIFICATIONS";
export const NOTIFICATIONS_OPEN = "NOTIFICATIONS_OPEN";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const CHECK_ALERT = "CHECK_ALERT";
export const NOTIFICATIONS_REQUEST = "NOTIFICATIONS_REQUEST";
export const BLACK_IMG_B64 ="data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=";